import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { useWave } from "@/hooks/useWave";
import { DefaultWaveWinnersDrop } from "./DefaultWaveWinnerDrop";
import { MemesWaveWinnersDrop } from "./MemesWaveWinnerDrop";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
interface WaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isApprovalWave?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
}
export const WaveWinnersDrop: React.FC<WaveWinnersDropProps> = t0 => {
  const $ = _c(9);
  const {
    winner,
    wave,
    onDropClick,
    isApprovalWave: t1,
    contentPresentation: t2
  } = t0;
  const isApprovalWave = t1 === undefined ? false : t1;
  const contentPresentation = t2 === undefined ? "default" : t2;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t3;
    if ($[0] !== onDropClick || $[1] !== wave || $[2] !== winner) {
      t3 = <MemesWaveWinnersDrop winner={winner} wave={wave} onDropClick={onDropClick} />;
      $[0] = onDropClick;
      $[1] = wave;
      $[2] = winner;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== contentPresentation || $[5] !== isApprovalWave || $[6] !== onDropClick || $[7] !== winner) {
    t3 = <DefaultWaveWinnersDrop winner={winner} onDropClick={onDropClick} isApprovalWave={isApprovalWave} contentPresentation={contentPresentation} />;
    $[4] = contentPresentation;
    $[5] = isApprovalWave;
    $[6] = onDropClick;
    $[7] = winner;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};